import { DocumentService } from '@dealstack/frontend/shared/dataExchange/services/document/document.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';

interface Props {
	dealId: string;
}

export const useDocumentClassifiers = ({ dealId }: Props) => {
	const {
		data: documentClassifiers,
		isLoading: isDocumentClassifiersLoading,
		error: documentClassifiersError,
	} = useQuery({
		// The deal rides on the `deal-id` header, so it stays in the key to keep the cache
		// separated per deal.
		queryKey: [API_PATHS.CLASSIFIER_DEAL_CLASSIFIER_GET, dealId],
		queryFn: ({ signal }) =>
			DocumentService.getDealClassifiers(API_PATHS.CLASSIFIER_DEAL_CLASSIFIER_GET, signal),
		enabled: !!dealId,
	});

	return {
		documentClassifiers: documentClassifiers?.payload,
		isDocumentClassifiersLoading,
		documentClassifiersError,
	};
};
